module.exports = __webpack_public_path__ + "static/howto1.0ad7ecca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/howto1.svg
// module id = 367
// module chunks = 221374088121123